import React, { useContext, useMemo } from 'react';
import {
    IPjmLocationsSidebarFiltersContext,
    IPjmLocationsSidebarFilters,
    PjmLocationSidebarFiltersContext,
} from './PjmLocationSidebarFiltersContext';
import { CollapseFilterWrapper } from '../../../../../components/sidebar-filters/CollapseFilterWrapper';
import { useSidebarFilterOptionsContext } from '../../../../energyUsageData/sidebar/context/SidebarFilterOptionsContext';
import { PjmStatusFilterSelect } from '../../../../../components/sidebar-filters/filter-select/PjmStatusFilterSelect';
import { PjmZoneFilterSelect } from '../../../../../components/sidebar-filters/filter-select/PjmZoneFilterSelect';
import { PjmLocationStateFilterSelect } from '../../../../../components/sidebar-filters/filter-select/PjmLocationStateFilterSelect';
import { PjmLocationZipCodeFilterSelect } from '../../../../../components/sidebar-filters/filter-select/PjmLocationZipCodeFilterSelect';
import { PjmEdcFilterSelect } from '../../../../../components/sidebar-filters/filter-select/PjmEdcFilterSelect';
import { PjmSyncDrhubStatusFilterSelect } from '../../../../../components/sidebar-filters/filter-select/PjmSyncDrhubStatusFilterSelect';

export const PjmLocationFilterKeys = {
    // Filters
    status: 'summaryInfo.status',
    zone: 'summaryInfo.zone',
    state: 'siteInfo.address.state',
    zipCode: 'siteInfo.address.zipCode',
    edc: 'summaryInfo.EDC.name',
    syncDrhubStatus: 'syncDrhubStatus',
} as const;

export type TPjmLocationFilterKey = (typeof PjmLocationFilterKeys)[keyof typeof PjmLocationFilterKeys];

export const PjmLocationFilterLabels = {
    [PjmLocationFilterKeys.status]: 'Status',
    [PjmLocationFilterKeys.zone]: 'Zone',
    [PjmLocationFilterKeys.state]: 'State',
    [PjmLocationFilterKeys.zipCode]: 'Zip Code',
    [PjmLocationFilterKeys.edc]: 'EDC',
    [PjmLocationFilterKeys.syncDrhubStatus]: 'DRHub Sync',
} as const;

interface IPjmLocationsSidebarFiltersProps {
    onFilterChange: (filters: IPjmLocationsSidebarFilters) => void;
}

export const PjmLocationsSidebarFilters: React.FC<IPjmLocationsSidebarFiltersProps> = ({ onFilterChange }) => {
    const { filters, handleFilterChange } = useContext<IPjmLocationsSidebarFiltersContext>(PjmLocationSidebarFiltersContext);
    const {
        isLoading: isFiltersLoading,
        pjmLocationStatusOptions,
        pjmLocationZoneOptions,
        pjmLocationStateOptions,
        pjmLocationZipCodeOptions,
        pjmLocationEdcOptions,
        pjmLocationSyncDrhubStatusOptions,
    } = useSidebarFilterOptionsContext();

    const handlePjmLocationsFilterChange = (key: string, value: unknown) => {
        handleFilterChange(key, value);
        onFilterChange({ ...filters, [key]: value });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflowY: 'auto' }}>
            {/* Filters */}
            <CollapseFilterWrapper label="Filters">
                <PjmStatusFilterSelect
                    label={PjmLocationFilterLabels[PjmLocationFilterKeys.status]}
                    value={filters[PjmLocationFilterKeys.status] || []}
                    onChange={value => handlePjmLocationsFilterChange(PjmLocationFilterKeys.status, value)}
                    options={pjmLocationStatusOptions}
                    isLoading={false}
                />
                <PjmZoneFilterSelect
                    label={PjmLocationFilterLabels[PjmLocationFilterKeys.zone]}
                    value={filters[PjmLocationFilterKeys.zone] || []}
                    onChange={value => handlePjmLocationsFilterChange(PjmLocationFilterKeys.zone, value)}
                    options={pjmLocationZoneOptions}
                    isLoading={false}
                />
                <PjmLocationStateFilterSelect
                    label={PjmLocationFilterLabels[PjmLocationFilterKeys.state]}
                    value={filters[PjmLocationFilterKeys.state] || []}
                    onChange={value => handlePjmLocationsFilterChange(PjmLocationFilterKeys.state, value)}
                    options={pjmLocationStateOptions}
                    isLoading={false}
                />
                <PjmLocationZipCodeFilterSelect
                    label={PjmLocationFilterLabels[PjmLocationFilterKeys.zipCode]}
                    value={filters[PjmLocationFilterKeys.zipCode] || []}
                    onChange={value => handlePjmLocationsFilterChange(PjmLocationFilterKeys.zipCode, value)}
                    options={pjmLocationZipCodeOptions}
                    isLoading={isFiltersLoading}
                />
                <PjmEdcFilterSelect
                    label={PjmLocationFilterLabels[PjmLocationFilterKeys.edc]}
                    value={filters[PjmLocationFilterKeys.edc] || []}
                    onChange={value => handlePjmLocationsFilterChange(PjmLocationFilterKeys.edc, value)}
                    options={pjmLocationEdcOptions}
                    isLoading={false}
                />
                <PjmSyncDrhubStatusFilterSelect
                    label={PjmLocationFilterLabels[PjmLocationFilterKeys.syncDrhubStatus]}
                    value={filters[PjmLocationFilterKeys.syncDrhubStatus] || []}
                    onChange={value => handlePjmLocationsFilterChange(PjmLocationFilterKeys.syncDrhubStatus, value)}
                    options={pjmLocationSyncDrhubStatusOptions}
                    isLoading={false}
                />
            </CollapseFilterWrapper>
        </div>
    );
};
